<template>
	<v-list-item :key="key" :disabled="saving" class="px-0 notification" :class="{unread: !watched}">
		<div class="mt-2 w-100">
			<div class="notification-body align-items-center">
				<router-link @click.native="handleNotification()" text :to="$notificationUrl(this.notification)" plain class="px-0 link d-flex">
					<div class="d-flex flex-row mr-2">
						<div>
						<avatar v-if="notification.what && notification.what.user" :user="notification.what.user" sm/>
						<v-avatar
							v-else
							color="primary"
							size="32"
						>
							<v-icon color="white">$notification</v-icon>
						</v-avatar>
						</div>
						<v-badge v-if="!watched" color="red" dot class="unread-badge" bordered overlap/>
					</div>
					{{ notification.message }}
				</router-link>
				<div class="mt-2">

				</div>
			</div>
			<div class="mt-3 d-flex flex-row w-100 align-items-center">
				<v-tooltip bottom content-class="font-12">
					<template v-slot:activator="{ on }">
						<span v-on="on" class="text-muted small">{{ $moment(notification.created_at).fromNow() }}</span>
					</template>
					{{ $moment(notification.created_at).format('LLL') }}
				</v-tooltip>
				<v-menu
					bottom
					min-width="250px"
					rounded
					offset-y
					left
				>
					<template v-slot:activator="{ on }">
						<v-btn
							v-on="on"
							icon
							rounded
							light
							class="ml-auto px-2"
							color="grey"
							:loading="saving"
						>
							<v-icon>$settings</v-icon>
						</v-btn>
					</template>
					<v-list dense>
						<v-list-item v-if="!watched" @click="markAsRead()" dense class="font-12 link">
							{{ $vuetify.lang.t('$vuetify.notifications.markAsRead') }}
						</v-list-item>
						<v-list-item v-else @click="markAsUnread()" dense class="font-12 link">
							{{ $vuetify.lang.t('$vuetify.notifications.markAsUnread') }}
						</v-list-item>
						<v-list-item @click="deleteNotification()" dense class="font-12 link">
							{{ $vuetify.lang.t('$vuetify.notifications.delete') }}
						</v-list-item>
					</v-list>
				</v-menu>
			</div>
		</div>
	</v-list-item>
</template>

<script>
import Avatar from '@/components/Avatar';
import {mapGetters} from 'vuex';
export default {
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	components: {
		Avatar
	},
	data() {
		return {
			key: 0,
			saving: false
		}
	},
	watch: {
		notification: {
			handler() {
				this.$nextTick(() => {
					this.key++;
				})
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			unreadNotifications: 'notifications/unreadNotifications'
		}),
		watched() {
			if(this.notification.watched_at) {
				return true;
			}
			return false;
		}
	},
	methods: {
		async handleNotification() {
			if(!this.notification.clicked_at) {
				this.markAsClicked();
			}
			this.$emit('close');
		},
		async markAsRead() {
			if(!this.notification.watched_at) {
				this.saving = true;
				await this.$store.dispatch('notifications/updateStatus', {
					action: 'watched',
					notification_ids: [this.notification.id]
				});
				this.$store.commit('notifications/decrementUnreadNotifications');
				this.$store.commit('notifications/incrementReadNotifications');
				this.saving = false;
			}
			return true;
		},
		async markAsUnread() {
			if(this.notification.watched_at) {
				this.saving = true;
				await this.$store.dispatch('notifications/updateStatus', {
					action: 'unwatched',
					notification_ids: [this.notification.id]
				});
				this.$store.commit('notifications/incrementUnreadNotifications');
				this.$store.commit('notifications/decrementReadNotifications');
				if(!this.unreadNotifications.length) {
					await this.$store.dispatch('notifications/getNotifications', {
						watched: 'no'
					})
				}
				this.saving = false;
			}
			return true;
		},
		async markAsClicked() {
			if(!this.notification.clicked_at) {
				this.saving = true;
				await this.$store.dispatch('notifications/updateStatus', {
					action: 'clicked',
					notification_ids: [this.notification.id]
				});
				this.saving = false;
			}
		},
		async deleteNotification() {

			this.saving = true;
			const res = await this.$store.dispatch('notifications/deleteNotification', this.notification);
			if(res.success) {
				this.$snackbar.success("Pomyślnie usunięto powiadomienie");
			}
			else {
				this.$snackbar.error({error: res.error})
			}
			this.saving = false;

		}
	}
}
</script>
<style lang="scss">

	.notification {
		&:hover {
			background: unset !important;
		}
		.notification-body {
			overflow-wrap: break-word;
			display: flex;
			flex-direction: row;
			cursor: pointer;
			&:hover {
				color: var(--v-accent-base);
			}
		}
		&.unread {
			// background: var(--v-accent-lighten2);
			.notification-body {
				font-weight: bold;
			}
		}
		.unread-badge {
			.v-badge__badge {
				border-radius: 12px !important;
				width: 12px !important;
				height: 12px !important;
			}
		}
	}
</style>
